import gql from "graphql-tag";
import { PageInfo, ProductTaxonomyFilterInput } from "../types/generalTypes";
import { Product } from "../types/productTypes";

export interface Brand {
  id: string;
  slug: string;
  name: string;
  brandData: {
    logo: {
      sourceUrl?: string;
    } | null;
  };
}

export interface GetBrandsVariables {
  limit: number;
  after?: string;
  search?: string;
  firstLetter?: string;
}

export interface GetBrandsResponse {
  productBrands: {
    nodes: Brand[];
    pageInfo?: PageInfo;
  };
}

export const getBrands = gql`
  query getBrands(
    $limit: Int
    $after: String
    $search: String
    $firstLetter: String
  ) {
    productBrands(
      first: $limit
      after: $after
      where: { search: $search, firstLetter: $firstLetter, hideEmpty: true }
    ) {
      nodes {
        id
        name
        brandData {
          logo {
            id
            sourceUrl
          }
        }
        slug
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export interface GetBrandsLettersResponse {
  productBrands: {
    brandsLetters: {
      letters: string[] | null;
    };
  };
}

export const getBrandsLetters = gql`
  query getBrandsLetters {
    productBrands {
      brandsLetters {
        letters
      }
    }
  }
`;

export interface GetBrandProductsVariables {
  limit: number;
  slug: string;
  category?: string;
  after?: string;
  field?: string;
  order?: string;
  taxonomyFilter?: ProductTaxonomyFilterInput[];
}

export interface GetBrandProductsResponse {
  products: {
    nodes: Product[];
    pageInfo?: PageInfo;
  };
}

export const getBrandProducts = gql`
  query getBrandProducts(
    $slug: [String]
    $limit: Int
    $after: String
    $category: String
    $field: ProductsOrderByEnum!
    $order: OrderEnum
  ) {
    products(
      first: $limit
      after: $after
      where: {
        category: $category
        orderby: { field: $field, order: $order }
        taxonomyFilter: {
          filters: { taxonomy: PRODUCT_BRANDS, terms: $slug }
          relation: AND
        }
      }
    ) {
      nodes {
        id
        slug
        databaseId
        name
        ... on VariableProduct {
          id
          name
          regularPrice(format: FORMATTED)
          salePrice(format: FORMATTED)
          productBrands {
            nodes {
              id
              name
              slug
            }
          }
        }
        ... on SimpleProduct {
          id
          name
          salePrice
          regularPrice
          productBrands {
            nodes {
              id
              name
              slug
            }
          }
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export interface GetBrandBySlugVariables {
  slug: string;
}

export interface GetBrandBySlugResponse {
  productBrands: {
    nodes: Brand[];
  };
}

export const getBrandBySlug = gql`
  query getBrandBySlug($slug: [String]) {
    productBrands(where: { slug: $slug }) {
      nodes {
        name
        brandData {
          logo {
            id
            sourceUrl
          }
        }
      }
    }
  }
`;

export const getHomeBrands = gql`
  query getHomeBrands {
    generalOptions {
      generalOptions {
        home {
          randomBrands {
            name
            slug
            brandData {
              logo {
                id
                sourceUrl(size: MEDIUM)
              }
            }
          }
        }
      }
    }
  }
`;
